<template>
  <div>
    <div class="search-box">
      <div class="input-item">
        <span class="label">文案关键词</span>
        <Input v-model="searchParams.queryKey" clearable placeholder="请输入" />
      </div>
      <div class="input-item">
        <span class="label">引用类型</span>
        <Select v-model="searchParams.momentsType" transfer placeholder="请选择引用类型" clearable>
          <Option value="6">图片</Option>
          <Option value="7">视频</Option>
          <Option value="8">文章</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">发布时间</span>
        <DatePicker
          type="daterange"
          split-panels
          separator="至"
          :transfer="true"
          placement="bottom"
          format="yyyy-MM-dd"
          placeholder="选择日期"
          :value="searchParams.date"
          @on-change="searchParams.date = $event"
        ></DatePicker>
      </div>
      <div class="btn-item">
        <Button type="primary" @click="searchAjax">查询</Button>
        <Button type="primary" class="btn-reset" ghost @click="resetSearch(), (searchParams.date = []), getClassArr(false)">重置</Button>
      </div>
    </div>

    <div class="tab-one">
      <Tabs v-model="activeTab" @on-click="changeTabOne">
        <TabPane :label="item.name + '(' + item.counts + ')'" :name="item.id" v-for="(item, i) in tabOneList" :key="i"></TabPane>
      </Tabs>
    </div>

    <div class="tab-two" v-if="tabTwoList.length">
      <div class="tab-item" v-for="(item, index) in tabTwoList" :key="index" :class="{ active: tabTwoAction == index }" @click="changeTabTwo(item, index)">
        <span>{{ item.name }}</span>
      </div>
    </div>

    <div class="tableBox">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="columnName">
          <div v-for="(item, i) in row.columnName" :key="i">
            <span>{{ item }}</span>
          </div>
        </template>

        <template slot-scope="{ row }" slot="contentText">
          <div class="title-content">
            <div>
              {{ row.content }}
            </div>
            <img v-if="getTime(row.publishTime)" src="@/static/images/contentManage/09.png"> 
          </div>
        </template>

        <template slot-scope="{ row }" slot="linkContent">
          <div v-if="row.momentsType == 6" class="linkBox">
            <div :class="{ imgOne: row.linkContentList.length == '1', imgBox: row.linkContentList.length > '1' }">
              <div v-for="(item, i) in row.linkContentList" :key="i" class="img">
                <img :src="item" :preview="row.id" :ref="'preview'+row.id">
              </div>
            </div>
          </div>
          <div v-if="row.momentsType == 7" class="linkBox">
            <div v-for="(item, i) in row.linkContentList" :key="i">
              <video v-if="row.linkContentList.length" controls width="200" :src="item" :poster="row.videoCover ? row.videoCover : ''"></video>
            </div>
          </div>
          <div v-if="row.momentsType == 8" class="linkBox">
            <span class="articleUrl" @click="articleUrl(row)">{{ row.article.title }}</span>
          </div>
        </template>
        <template slot-scope="{ row }" slot="tags">
          <div class="tags">
            <Tag v-for="(item, index) in row.tagList" :key="index" color="primary">{{ item }}</Tag>
            <span v-if="!row.tagList.length">-</span>
          </div>
        </template>
        <template slot-scope="{ row }" slot="isPublish">
          <div @click="editDeail(row)">
            <i-switch v-model="row.isPublish" true-value="1" false-value="0">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </div>
        </template>
        <template slot-scope="{ row }" slot="action">
          <div>
            <span class="table-btn" @click="getDetail(row.id, row.publishTime)">预览</span>

            <span class="table-btn" v-if="$units.pointAction('content_6_1') && row.isImport == '0'" @click="$refs.importMomentRef.open(row, 0, row.momentsType)">导入</span>
            <span class="table-btn grey" v-else-if="$units.pointAction('content_6_1') && row.isImport != '0'">已导入</span>

            <span class="table-btn" @click="$refs.importMomentRef.open(row, 1, row.momentsType)" v-if="$units.pointAction('content_6_1') && row.isImport == '0'"
              >导入并发布</span
            >
            <span class="table-btn grey" v-else-if="$units.pointAction('content_6_1') && row.isImport != '1'">导入并发布</span>
          </div>
        </template>
      </Table>
      <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="pageChange" style="text-align: center; margin-top: 20px" />
    </div>

    <!-- 导入 -->
    <momentMaterialsImport ref="importMomentRef" @success="getList"></momentMaterialsImport>

    <previewModal ref="previewModal" :articleList="articleList"></previewModal>
  </div>
</template>
<script>
import { filterTime } from '@/api/filter';
import { pageTool } from '@/api/mixins';
import momentMaterialsImport from './momentMaterialsImport';
import previewModal from './momentMaterialsPreview';
export default {
  mixins: [pageTool],
  components: {
    momentMaterialsImport,
    previewModal
  },
  mounted() {
    // 组件加载完成后，打印方法和属性
    this.$preview.on('imageLoadComplete', (e, item) => {
      this.$preview.self.options.bgOpacity = 0.5;
    });
    //异步插入的图片，数据更新后更新视图
    this.$previewRefresh();
  },
  data() {
    return {
      tableLoading: false, //表格loading
      searchParams: {},
      tableData: [],
      activeTab: '',
      tabOneList: [],
      tabTwoList: [],
      tabTwoAction: 0,
      tabTwoActionId: '',
      total: 0,
      pageNo: 1,
      pageSize: 10,
      articleList: [],
      columns: [
        {
          title: '文案',
          align: 'center',
          key: 'content',
          slot: 'contentText',
          minWidth: 250
        },
        {
          title: '引用内容',
          align: 'center',
          slot: 'linkContent',
          minWidth: 250,
          tooltip: true
        },
        {
          title: '标签',
          align: 'center',
          slot: 'tags',
          minWidth: 180,
          tooltip: true
        },
        {
          title: '发布用户',
          align: 'center',
          key: 'nickname',
          minWidth: 200,
          tooltip: true
        },
        {
          title: '发布时间',
          align: 'center',
          key: 'publishTime',
          minWidth: 200,
          tooltip: true
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 220,
          fixed: 'right'
        }
      ]
    };
  },
  methods: {
    async getData() {
      await this.getClassArr(true);
      this.activeTab = this.tabOneList[0].id;
      this.tabTwoAction = 0;
      this.getList();
      this.listCallback();
    },

    getTime(time) {
      let nowdate = filterTime(new Date(), 'YYYY-MM-DD');
      if (filterTime(time, 'YYYY-MM-DD') == nowdate) {
        return true;
      } else {
        return false;
      }
    },

    // 搜索
    searchAjax() {
      this.pageNum = 1;
      this.getList();
      this.getClassArr(false);
    },

    // 获取列表参数
    getParams() {
      const params = Object.assign({}, this.searchParams);
      if (params.date && params.date.length) {
        params.startPublishTime = params.date[0] && filterTime(params.date[0], 'YYYY-MM-DD');
        params.endPublishTime = params.date[1] && filterTime(params.date[1], 'YYYY-MM-DD');
        delete params.date;
      } else {
        delete params.date;
      }
      return params;
    },

    // tab分类
    getClassArr(query) {
      return this.$http({
        url: '/buz/cms/materialsLibrary/friendsCircle/columnList',
        type: 'POST',
        data: {
          ...this.getParams()
        }
      }).then(res => {
        this.tabOneList = res.data;
        if (res.data && res.data[0].children) {
          if (query) {
            this.tabTwoList = res.data[0].children;
            this.tabTwoActionId = this.tabTwoList[0].id;
          }
        } else {
          this.tabTwoActionId = res.data[0].id;
        }
      });
    },

    getList() {
      this.listLoading = true;
      this.$http({
        url: '/buz/cms/materialsLibrary/queryFriendsCircle',
        type: 'POST',
        data: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          columnIds: [this.tabTwoActionId],
          ...this.getParams()
        }
      })
        .then(res => {
          this.tableData = res.data;
          this.total = res.total;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },

    // 切换一级分类
    changeTabOne(val) {
      this.tabTwoList = [];
      this.tabTwoAction = 0;
      this.pageNum = 1;
      if (!val) {
        this.tabTwoActionId = '';
      } else {
        this.tabOneList.map(item => {
          if (item.id == val) {
            if (item.children && item.children.length) {
              this.tabTwoList = item.children;
              this.tabTwoActionId = item.children[0].id;
            } else {
              this.tabTwoList = [];
              this.tabTwoActionId = val;
            }
          }
        });
      }
      this.getList();
    },

    changeTabTwo(item, index) {
      this.tabTwoAction = index;
      this.tabTwoActionId = item.id;
      this.pageNum = 1;
      this.getList();
    },

    articleUrl(row) {
      window.open(row.url, '_blank');
    },

    editDeail(item) {
      this.$http({
        url: '/buz/friendsCircle/updatePublishStatus',
        type: 'POST',
        data: {
          id: item.id,
          isUse: item.isPublish
        }
      }).then(res => {
        this.getList();
      });
    },

    listCallback() {
      setTimeout(() => {
        const father = document.getElementsByClassName('ivu-table-fixed-right');
        // for (let i = 0; i < father.length; i++) {
        //   let p = father[i].getElementsByTagName('img');
        //   for (let index = 0; index < p.length; index++) {
        //     p[index].removeAttribute('preview');
        //   }
        // }
        this.$previewRefresh();
      }, 1500);
    },

    getDetail(id, publishTime) {
      this.$http({
        url: '/buz/cms/materialsLibrary/queryFriendCircleDetail',
        type: 'GET',
        data: {
          articleId: id
        }
      }).then(res => {
        this.$refs.previewModal.open(res.data, publishTime);
        if (res.data.article) {
          this.articleList = [res.data.article];
        }
      });
    },

    pageChange(pageNum) {
      this.pageNum = pageNum;
      this.getList(pageNum);
    },

    // 详情
    toDetaile(item) {
      window.open(item.url, '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.tab-one {
  position: relative;
  /deep/.ivu-tabs-nav {
    max-width: 80%;
    overflow-x: auto;
  }
  .ivu-tabs {
    height: 42px;
    margin-bottom: 14px;
  }
  /deep/ .ivu-tabs-tab-active {
    font-weight: bold;
  }
}

.tab-two {
  display: flex;
  margin-bottom: 15px;
  .tab-item {
    margin-right: 15px;
    padding: 7px 16px;
    background: #f5f7f9;
    border-radius: 2px;
    cursor: pointer;
    span {
      font-size: 12px;
      color: #727c8e;
    }
    &.active {
      background: #236dff;
      span {
        color: #ffffff;
      }
    }
  }
}
.linkBox {
  padding: 10px 0;
}

video {
  width: 100%;
  height: 100%;
}

.imgBox {
    display: flex;

    .img {
      width: 38px;
      height: 68px;

      &:not(:first-child) {
        width: 19px;
        height: 68px;
        overflow: hidden;
      }
    }

    img {
      width: 38px;
      height: 68px;
    }
  }

  .imgOne {
    img {
      max-width: 95px;
      max-height: 68px;
      margin: 0 52px;
      object-fit: cover;
    }
  }

.articleUrl {
  color: #236dff;

  &:hover {
    cursor: pointer;
  }
}
.tags {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
.grey {
  color: #c5c8ce;
  cursor: default;
}
.title-content {
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 17px;
    height: 20px;
    margin-left: 2px;
    margin-bottom: 10px;
  }
}
</style>
